import type { RouteStep } from '../../typings'

export const getStepId = (step: RouteStep): string =>
  // step.ref will become the string 'undefined' or 'null'
  // this will generate an unique id in every case
  // so no more refinement needs to be done
  `${step.ref}-${step.type}`
